"use strict"
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        loadingComplete: Boolean,
    },
});